module.exports = __webpack_public_path__ + "img/WFH-Sp.8392446f.png";